import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@src/app/shared/shared.module';
import { ActivityBannerComponent } from '@src/app/standalone-components/activity-banner/activity-banner.component';
import { HomeNotificationComponent } from '@src/app/standalone-components/home-notification/home-notification.component';
import { MemeSearchComponent } from '@src/app/standalone-components/meme-search/meme-search.component';
import { SocialscanTableTheadThComponent } from '@src/app/standalone-components/socialscan-table-thead-th/socialscan-table-thead-th.component';
import { QRCodeModule } from 'angularx-qrcode';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { ChainSelectComponent } from './components/chain-select/chain-select.component';
import { RecentTgAlertItemComponent } from './components/recent-tg-alert-item/recent-tg-alert-item.component';
import { ShareToSocialmediaModalComponent } from './components/share-to-socialmedia-modal/share-to-socialmedia-modal.component';
import { WatchlistAgentCardComponent } from './components/watchlist-agent-card/watchlist-agent-card.component';
import { WatchlistAgentInfoComponent } from './components/watchlist-agent-info/watchlist-agent-info.component';
import { WatchlistAgentSetupGuideComponent } from './components/watchlist-agent-setup-guide/watchlist-agent-setup-guide.component';
import { MemeDashboardRoutingModule } from './meme-dashboard-routing.module';
import { MemeDashboardComponent } from './meme-dashboard.component';
import { BaseTreemapComponent } from './pages/dashboard-home/components/token-treemap/base-treemap/base-treemap.component';
import { TokenTreemapByChainComponent } from './pages/dashboard-home/components/token-treemap/token-treemap-by-chain/token-treemap-by-chain.component';
import { TokenTreemapComponent } from './pages/dashboard-home/components/token-treemap/token-treemap.component';
import { DashboardHomeComponent } from './pages/dashboard-home/dashboard-home.component';
import { HolderHoldingsComponent } from './pages/holder-detail/components/holder-holdings/holder-holdings.component';
import { HolderTxnsComponent } from './pages/holder-detail/components/holder-txns/holder-txns.component';
import { HolderDetailComponent } from './pages/holder-detail/holder-detail.component';
import { AddWatchlistModalComponent } from './pages/my-watchlist/add-watchlist-modal/add-watchlist-modal.component';
import { MyWatchlistComponent } from './pages/my-watchlist/my-watchlist.component';
import { HighlightedHoldersComponent } from './pages/token-detail/components/highlighted-holders/highlighted-holders.component';
import { HighlightedTxnsComponent } from './pages/token-detail/components/highlighted-txns/highlighted-txns.component';
import { TokenDetailComponent } from './pages/token-detail/token-detail.component';
import { WatchlistDetailComponent } from './pages/watchlist-detail/watchlist-detail.component';
import { WatchlistSmartBuysComponent } from './pages/watchlist-detail/watchlist-smart-buys/watchlist-smart-buys.component';
import { WatchlistMarketplaceComponent } from './pages/watchlist-marketplace/watchlist-marketplace.component';
import { MemeStarSettingsComponent } from './components/meme-star-settings/meme-star-settings.component';
import { ProfileSettingsDropdownComponent } from '../../standalone-components/profile-settings-dropdown/profile-settings-dropdown.component';
import { TgBotEntryCardComponent } from '../../standalone-components/tg-bot-entry-card/tg-bot-entry-card.component';
import { DefaultTokenInfoComponent } from './pages/token-detail/components/default-token-info/default-token-info.component';
import { V2TokenInfoComponent } from './pages/token-detail/components/v2-token-info/v2-token-info.component';
@NgModule({
    declarations: [
        MemeDashboardComponent,
        DashboardHomeComponent,
        HolderDetailComponent,
        TokenDetailComponent,
        BaseTreemapComponent,
        TokenTreemapComponent,
        MyWatchlistComponent,
        AddWatchlistModalComponent,
        HighlightedTxnsComponent,
        HighlightedHoldersComponent,
        HolderHoldingsComponent,
        HolderTxnsComponent,
        WatchlistAgentInfoComponent,
        WatchlistAgentCardComponent,
        WatchlistMarketplaceComponent,
        WatchlistAgentSetupGuideComponent,
        WatchlistDetailComponent,
        RecentTgAlertItemComponent,
        WatchlistSmartBuysComponent,
        ShareToSocialmediaModalComponent,
        ChainSelectComponent,
        TokenTreemapByChainComponent,
        DefaultTokenInfoComponent,
        V2TokenInfoComponent,
    ],
    imports: [
        CommonModule,
        MemeDashboardRoutingModule,
        SharedModule,
        HomeNotificationComponent,
        ActivityBannerComponent,
        SocialscanTableTheadThComponent,
        ScrollingModule,
        NzSkeletonModule,
        NzCheckboxModule,
        NzRadioModule,
        NzTableModule,
        NzAlertModule,
        NzDropDownModule,
        NzImageModule,
        NzAvatarModule,
        NzAutocompleteModule,
        NzModalModule,
        NzUploadModule,
        NzInputNumberModule,
        MemeSearchComponent,
        QRCodeModule,
        MemeStarSettingsComponent,
        ProfileSettingsDropdownComponent,
        TgBotEntryCardComponent,
    ],
    providers: [],
})
export class MemeDashboardModule {}
